import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";
@Component({
  selector: "app-transaction-detail-header-shared",
  templateUrl: "./transaction-detail-header-shared.component.html",
  styleUrls: ["./transaction-detail-header-shared.component.scss"],
})
export class TransactionDetailHeaderSharedComponent implements OnInit {
  @Input() payment: any;
  @Input() selectedTotal: any;
  @Input() currency: any;
  @Input() receiptModal: Boolean;
  @Input() refundModalPageOne: Boolean;
  @Input() voidModalPageOne: Boolean;
  @Input() refundModalPageTwo: Boolean;
  @Input() voidModalPageTwo: Boolean;
  @Input() refundModalSuccess: Boolean;
  @Input() voidModalSuccess: Boolean;
  @Input() refundModalLoader: Boolean;
  @Input() voidModalLoader: Boolean;
  @Input() pRefundModalPageOne: Boolean;
  @Input() cRefundModalPageOne: Boolean;
  @Input() pRefundModalPageTwo: Boolean;
  @Input() cRefundModalPageTwo: Boolean;
  @Input() orderEditModalPageOne: Boolean;
  @Input() orderEditModalPageTwo: Boolean;
  @Input() orderEditModalPageThree: Boolean;
  @Input() chageLoader: Boolean;
  @Output() backtoTransactionDetail: EventEmitter<any> = new EventEmitter();
  @Output() backtoRefundPageOne: EventEmitter<any> = new EventEmitter();
  @Output() backtoVoidPageOne: EventEmitter<any> = new EventEmitter();
  @Output() backPRefundPageOne: EventEmitter<any> = new EventEmitter();
  @Output() backCRefundPageOne: EventEmitter<any> = new EventEmitter();
  @Output() backtoEditorderPageTwo: EventEmitter<any> = new EventEmitter();
  constructor(public offcanvasService: NgbOffcanvas) {}

  ngOnInit(): void {
    console.log("FROM_HEADER_COMPONENT", this.payment)
    if (!Boolean(this.currency)) {
      this.currency = "$";
    }
  }
  backtoTransactionDetailFunc() {
    console.log("backtoTransactionDetailFunc");
    this.backtoTransactionDetail.emit();
  }
  backtoRefundPageOneFunc() {
    this.backtoRefundPageOne.emit();
  }
  backtoVoidPageOneFunc() {
    this.backtoVoidPageOne.emit();
  }

  backtoCRefundPageOneFunc() {
    this.backCRefundPageOne.emit();
  }
  backtoprRefundPageOneFunc() {
    console.log("backtoprRefundPageOneFunc");
    this.backPRefundPageOne.emit();
  }
  backtoEditorderPageTwoFunc() {
    this.backtoEditorderPageTwo.emit();
  }
  close() {
    this.backtoTransactionDetailFunc()
    this.offcanvasService.dismiss('Cross click')
  }
}
